import React from "react";
import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
export const Area = styled.div.withConfig({
  displayName: "ToolButton__Area",
  componentId: "sc-1ulns94-0"
})(["background-color:", ";border-radius:", ";text-align:center;color:white;height:40px;width:40px;margin:1px;padding:2px;font-size:x-small;cursor:pointer;&:hover{background-color:", ";}&.selected{background-color:", ";border:2px solid black;}&.disabled{cursor:not-allowed;background-color:", ";}&.row{float:left;}"], UiConstants.COLOR_DARK_BUTTON, UiConstants.BORDER_RADIUS, UiConstants.COLOR_DARK_BUTTON_HOVER, UiConstants.COLOR_SELECTION_HIGHLIGHT, UiConstants.COLOR_DISABLED);
export const IconFont = styled.div.withConfig({
  displayName: "ToolButton__IconFont",
  componentId: "sc-1ulns94-1"
})(["font-size:x-large;"]);
export const ToolButton = properties => {
  const handleClick = () => {
    if (!properties.disabled) properties.onChange();
  };

  let classNames;
  if (properties.disabled) classNames = properties.disabled ? 'disabled' : '';else classNames = properties.checked ? 'selected' : '';
  if (properties.floatLeft) classNames += ' row';
  return /*#__PURE__*/React.createElement(Area, {
    onClick: handleClick,
    className: classNames
  }, properties.text, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(IconFont, null, /*#__PURE__*/React.createElement(properties.icon, {
    color: '#FFF'
  })));
};